const springSystem = {
  emitters: [
    {
      id: 1,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [-0.2, 0],
          [0.4, 0],
        ],
      },
      speed: {
        type: 'range',
        value: [0.5, 1.7],
      },
      rate: {
        type: 'float',
        value: 75,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'image',
        },
        wobble: {
          type: 'range',
          value: [0, 10],
        },
        gravity: {
          type: 'float',
          value: 0.003,
        },
        image: {
          type: 'string',
          value: 'https://sharefolio-public.s3.amazonaws.com/leaf.png',
        },
        scale: {
          type: 'range',
          value: [0.1, 0.4],
        },
        rotation: {
          type: 'range',
          value: [0, 6.283],
        },
        rotationRate: {
          type: 'range',
          value: [-0.01, 0.01],
        },
        drag: {
          type: 'vector',
          value: [0.1, 0],
        },
      },
    },
    {
      id: 2,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [-0.2, 0.4],
          [0.05, 1],
        ],
      },
      speed: {
        type: 'range',
        value: [0.5, 1.7],
      },
      rate: {
        type: 'float',
        value: 75,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'image',
        },
        wobble: {
          type: 'range',
          value: [0, 10],
        },
        gravity: {
          type: 'float',
          value: 0.003,
        },
        image: {
          type: 'string',
          value: 'https://sharefolio-public.s3.amazonaws.com/leaf.png',
        },
        scale: {
          type: 'range',
          value: [0.1, 0.4],
        },
        rotation: {
          type: 'range',
          value: [0, 6.283],
        },
        rotationRate: {
          type: 'range',
          value: [-0.01, 0.01],
        },
        drag: {
          type: 'vector',
          value: [0.1, 0],
        },
      },
    },
    {
      id: 4,
      layer: {
        type: 'string',
        value: 'foreground',
      },
      position: {
        type: 'vectorRange',
        value: [
          [-0.2, 0.95],
          [1.2, 1],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'range',
        value: [-0.1, 0.1],
      },
      rate: {
        type: 'float',
        value: 12,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 6,
        },
        shape: {
          type: 'string',
          value: 'image',
        },
        scale: {
          type: 'range',
          value: [0.6, 1],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        wobble: {
          type: 'float',
          value: 1,
        },
        rotation: {
          type: 'range',
          value: [-0.1, 0.1],
        },
        drag: {
          type: 'vector',
          value: [1.5, 1.5],
        },

        color: {
          type: 'colorOverLife',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 255, 0],
            },
            {
              keyframe: 10,
              value: [255, 255, 255, 0.8],
            },
            {
              keyframe: 90,
              value: [255, 255, 255, 0.8],
            },
            {
              keyframe: 100,
              value: [255, 255, 255, 0],
            },
          ],
        },
        image: {
          type: 'string',
          value: 'https://sharefolio-public.s3.amazonaws.com/grass1.png',
        },
      },
    },
    {
      id: 5,
      layer: {
        type: 'string',
        value: 'foreground',
      },
      position: {
        type: 'vectorRange',
        value: [
          [-0.2, 1.5],
          [1.2, 1.5],
        ],
      },
      angle: {
        type: 'float',
        value: -0.75,
      },
      speed: {
        type: 'range',
        value: [2, 3],
      },
      rate: {
        type: 'float',
        value: 30,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 2,
        },
        shape: {
          type: 'string',
          value: 'image',
        },
        scale: {
          type: 'range',
          value: [0.2, 0.4],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        gravity: {
          type: 'float',
          value: 0.005,
        },
        wobble: {
          type: 'float',
          value: 1,
        },
        rotation: {
          type: 'range',
          value: [0, 6.28],
        },
        rotationRate: {
          type: 'range',
          value: [-0.04, 0.04],
        },
        drag: {
          type: 'vector',
          value: [1, 1],
        },

        color: {
          type: 'colorOverLife',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 255, 0],
            },
            {
              keyframe: 30,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 70,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 100,
              value: [255, 255, 255, 0],
            },
          ],
        },
        image: {
          type: 'string',
          value: 'https://sharefolio-public.s3.amazonaws.com/grass1.png',
        },
      },
    },
    {
      id: 6,
      layer: {
        type: 'string',
        value: 'foreground',
      },
      position: {
        type: 'vectorRange',
        value: [
          [-0.4, 1.5],
          [1.2, 1.8],
        ],
      },
      angle: {
        type: 'float',
        value: -0.75,
      },
      speed: {
        type: 'range',
        value: [3, 3.5],
      },
      rate: {
        type: 'float',
        value: 10,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 2,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },
        scale: {
          type: 'range',
          value: [1, 2],
        },
        gravity: {
          type: 'float',
          value: 0,
        },
        wobble: {
          type: 'float',
          value: 2,
        },
        drag: {
          type: 'vector',
          value: [2, 2],
        },
        color: {
          type: 'colorOverLife',
          color: '#a4e031',
          value: [
            {
              keyframe: 0,
              value: [164, 224, 49, 0],
            },
            {
              keyframe: 30,
              value: [164, 224, 49, 0.8],
            },
            {
              keyframe: 70,
              value: [164, 224, 49, 0.8],
            },
            {
              keyframe: 100,
              value: [164, 224, 49, 0],
            },
          ],
        },
      },
    },
    {
      id: 10,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [-0.1, 1.05],
          [1.2, 1.25],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0,
      },
      rate: {
        type: 'float',
        value: 20,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 12,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0,
        },
        scale: {
          type: 'range',
          value: [40, 60],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#103110',
          value: [
            {
              keyframe: 0,
              value: [16, 49, 16, 0],
            },
            {
              keyframe: 40,
              value: [16, 49, 16, 0.25],
            },
            {
              keyframe: 60,
              value: [16, 49, 16, 0.25],
            },
            {
              keyframe: 100,
              value: [16, 49, 16, 0],
            },
          ],
        },
      },
    },
    {
      id: 11,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 0.2],
          [1.2, 1.2],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0.1,
      },
      rate: {
        type: 'float',
        value: 11,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 6,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0.0005,
        },
        scale: {
          type: 'range',
          value: [20, 200],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#1ec24a',
          value: [
            {
              keyframe: 0,
              value: [30, 194, 73, 0],
            },
            {
              keyframe: 20,
              value: [30, 194, 73, 0.002],
            },
            {
              keyframe: 40,
              value: [30, 194, 73, 0.002],
            },
            {
              keyframe: 100,
              value: [30, 194, 73, 0],
            },
          ],
        },
      },
    },
  ],
  effects: [
    {
      type: 'time',
      emitters: [1, 2, 4, 10],
      energy: 'above',
      data: {
        amount: 2,
      },
    },
    {
      type: 'impulse',
      emitters: [1, 2],
      energy: 'above',
      data: {
        direction: -1,
        amount: 0.01,
      },
    },
    {
      type: 'impulse',
      emitters: [4],
      energy: 'above',
      data: {
        direction: 0,
        amount: 0.001,
      },
    },
    {
      type: 'spawnOffset',
      emitters: [5, 6],
      energy: 'above',
      data: {
        amount: [0, -0.5],
      },
    },
  ],
}

export default springSystem
